export default class ListAllWorkTypeGroupsError extends Error {

}
